export const closest = (element, selectors) => {
  if (typeof element.closest === 'function') {
    return element.closest(selectors);
  }

  if (element.matches(selectors)) {
    return element;
  }

  if (element.parentNode !== global.document) {
    return closest(element.parentNode, selectors);
  }

  return null;
};

const closestElement = (element, targetElement) => {
  if (!element) {
    return null;
  }

  if (element === targetElement) {
    return targetElement;
  }

  if (element.parentNode !== global.document) {
    return closestElement(element.parentNode, targetElement);
  }

  return null;
};

export { closestElement };
